__webpack_require__.p = "/assets/turbo/fcdca24b/baurde/_next/";